export const isExisty = (value: any) => value !== null && value !== undefined;

export const isEmpty = (value: any) => value?.length === 0 || value === '' || !isExisty(value);

export const matchRegexp = (regexp: RegExp | string, value: string | null | undefined) => {
    const validationRegexp = regexp instanceof RegExp ? regexp : new RegExp(regexp);
    return isEmpty(value) || validationRegexp.test(value as string);
};
